import type { CheckoutGTMFlowType } from "@jti/tracker";

export type CheckoutFastFlowContextValue = {
  isCheckoutFastFlowInProgress: boolean;
  shippingInfoPrefilled: boolean;
  paymentInfoPrefilled: boolean;
  checkoutFlowType: CheckoutGTMFlowType | null;
};
